import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e9650b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"font-weight":"400"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fff"} }, "기관정보수정", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "기관정보수정", -1))
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, null, -1))

import { reactive, ref } from 'vue';
import axios from 'axios';
import { useStore } from 'vuex';
import DaumAddr from '@/components/api/DaumAddr.vue'

import {
  emailRule,
  phoneNumberRule,
  bossNameRule,
  localNumberRule,
  addrRule,
  bizNumberRule,
  bankNumRule,
  bankOwnerRule
} from '@/composables/rules';
interface SisulInfo {
  sisul_id: string;
  sisul_addr: string;
  sisul_tell: string;
  sisul_boss_name: string;
  sisul_boss_phone: string;
  sisul_boss_email: string;
  sisul_biz_num: string;
  sisul_bank: string;
  sisul_bank_num: string;
  sisul_bank_owner: string;
}

interface State {
  SsInfoBox: SisulInfo;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminCompBasicEdit',
  emits: ['success'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const dialog = ref(false);
const snackbar = ref(false);
const snacktext = ref(`메일이 전송되었습니다. 인증번호는 5분간 유효합니다.`);
const snacktime = ref(5000);

const bankValue= [
'기업은행',
'국민은행',
'외환은행',
'수협은행',
'농협은행',
'지역농협',
'우리은행',
'SC제일은행',
'서울은행',
'한국씨티은행',
'대구은행',
'부산은행',
'광주은행',
'제주은행',
'전북은행',
'경남은행',
'새마을금고연합회',
'신협중앙회',
'하나은행',
'신한은행',
'케이뱅크',
'카카오뱅크',
'토스뱅크'
]
const store = useStore();

// 타입 정의
const form = reactive({
  sisul_id: '',
  sisul_addr: '',
  sisul_tell: '',
  sisul_boss_name: '',
  sisul_boss_phone: '',
  sisul_boss_email: '',
  sisul_biz_num: '',
  sisul_bank: '',
  sisul_bank_num: '',
  sisul_bank_owner: '',
});
//eslint-disable-next-line
const updateAddress = (address: any) => {
  form.sisul_addr = `${address.address}`;
};
const openDialog = () => {
  dialog.value = true;
  const Ss = (store.state as State).SsInfoBox;
  form.sisul_id = Ss.sisul_id;
  form.sisul_addr = Ss.sisul_addr;
  form.sisul_tell = Ss.sisul_tell?.replace(/\D/g, '');
  form.sisul_boss_name = Ss.sisul_boss_name;
  form.sisul_boss_phone = Ss.sisul_boss_phone?.replace(/\D/g, '');
  form.sisul_boss_email = Ss.sisul_boss_email;
  form.sisul_biz_num = Ss.sisul_biz_num?.replace(/\D/g, '');
  form.sisul_bank = Ss.sisul_bank;
  form.sisul_bank_num = Ss.sisul_bank_num;
  form.sisul_bank_owner = Ss.sisul_bank_owner;
}

const closeDialog = () => {
  dialog.value = false;
}

const updateSsInfo = async () => {
  try {
    const checkAndLog = (rule: (v: string) => boolean | string, value: string, ruleName: string) => {
      const ruleResult = rule(value);
      if (typeof ruleResult === 'string') {
        alert(`${ruleName} 확인해주세요.`);
        return true;
      } else {
        return false;
      }
    };

    const isAddrValid = addrRule.some(rule => checkAndLog(rule, form.sisul_addr, '기관 주소를'));
    if (isAddrValid) return;

    const isBNValid = bossNameRule.some(rule => checkAndLog(rule, form.sisul_boss_name, '대표자 성명을'));
    if (isBNValid) return;

    const isBPValid = phoneNumberRule.some(rule => checkAndLog(rule, form.sisul_boss_phone, '대표자 휴대폰번호를'));
    if (isBPValid) return;

    const isBEValid = emailRule.some(rule => checkAndLog(rule, form.sisul_boss_email, '대표자 이메일을'));
    if (isBEValid) return;

    const response = await axios.put('/api/updateSsInfo', { form: form });
    const result = response.data;
    if (result.success === true) {
      emit('success');
      alert('기관정보 수정이 완료되었습니다.');
      dialog.value = false;
    } else {
      alert('기관정보 수정에 실패하였습니다. 관리자에게 문의해주세요.');
    }
  } catch (error) {
    alert('기관정보 수정을 처리할 수 없습니다.');
    console.error(error);
  }
};



return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        onClick: openDialog,
        style: {"width":"100%"},
        color: "indigo",
        class: "btnColorUpdate"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialog).value = $event)),
      height: "800px",
      style: {"width":"500px"},
      class: "fontNotoSans400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { style: {"padding":"20px !important"} }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createVNode(_component_v_form, { class: "wageClientInfoForm" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  "prepend-inner-icon": "mdi-note-text-outline",
                  variant: "outlined",
                  label: "사업자등록번호",
                  type: "text",
                  modelValue: form.sisul_biz_num,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.sisul_biz_num) = $event)),
                  maxlength: "11",
                  rules: _unref(bizNumberRule),
                  color: "indigo",
                  autocomplete: "off"
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(DaumAddr, {
                  onUpdateAddress: updateAddress,
                  addr: form.sisul_addr
                }, null, 8, ["addr"]),
                _createVNode(_component_v_text_field, {
                  "prepend-inner-icon": "mdi-phone-classic",
                  variant: "outlined",
                  label: "기관 전화번호",
                  type: "text",
                  modelValue: form.sisul_tell,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.sisul_tell) = $event)),
                  maxlength: "11",
                  rules: _unref(localNumberRule),
                  color: "indigo",
                  autocomplete: "off"
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_select, {
                  variant: "outlined",
                  "prepend-inner-icon": "mdi-bank-outline",
                  label: "은행명",
                  items: bankValue,
                  modelValue: form.sisul_bank,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.sisul_bank) = $event)),
                  color: "indigo",
                  autocomplete: "off",
                  class: "comeWaySelect"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  "prepend-inner-icon": "mdi-wallet",
                  variant: "outlined",
                  label: "계좌번호(숫자만 입력해주세요.)",
                  type: "text",
                  modelValue: form.sisul_bank_num,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.sisul_bank_num) = $event)),
                  maxlength: "20",
                  rules: _unref(bankNumRule),
                  color: "indigo",
                  autocomplete: "off"
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  "prepend-inner-icon": "mdi-shield-account",
                  variant: "outlined",
                  label: "예금주",
                  type: "text",
                  modelValue: form.sisul_bank_owner,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.sisul_bank_owner) = $event)),
                  maxlength: "10",
                  rules: _unref(bankOwnerRule),
                  color: "indigo",
                  autocomplete: "off"
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  "prepend-inner-icon": "mdi-account-tie",
                  variant: "outlined",
                  label: "대표자 성명",
                  type: "text",
                  modelValue: form.sisul_boss_name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.sisul_boss_name) = $event)),
                  maxlength: "10",
                  rules: _unref(bossNameRule),
                  color: "indigo",
                  autocomplete: "off"
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  "prepend-inner-icon": "mdi-cellphone",
                  variant: "outlined",
                  label: "대표자 휴대폰 번호",
                  type: "text",
                  modelValue: form.sisul_boss_phone,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.sisul_boss_phone) = $event)),
                  maxlength: "11",
                  rules: _unref(phoneNumberRule),
                  color: "indigo",
                  autocomplete: "off"
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  "prepend-inner-icon": "mdi-email-variant",
                  variant: "outlined",
                  label: "대표자 이메일",
                  hint: "이메일 형식을 맞춰주세요.",
                  type: "email",
                  modelValue: form.sisul_boss_email,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.sisul_boss_email) = $event)),
                  maxlength: "50",
                  rules: _unref(emailRule),
                  color: "indigo",
                  autocomplete: "off"
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_btn, {
                  class: "clientInfoBtn",
                  onClick: updateSsInfo
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("수정완료")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  onClick: closeDialog,
                  class: "cancelRegistBtn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("취소")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_snackbar, {
            modelValue: snackbar.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((snackbar).value = $event)),
            snacktime: snacktime.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(snacktext.value), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "snacktime"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_5
  ], 64))
}
}

})